/* ============================================================
   Mahalle Combobox — searchable dropdown component
   ------------------------------------------------------------
   HTML kontratı:
     <div class="mahalle-combobox" data-mahalle-combobox>
       <input data-mahalle-input ... />
       <button type="button" data-mahalle-toggle>▼</button>
       <div data-mahalle-dropdown hidden></div>
     </div>
   ------------------------------------------------------------
   Kullanım:
     var c = window.MytheMahalle.attach(containerEl);
     c.setItems([{name:'Atatürk Mahallesi'}, ...]);
     c.clear();
   ------------------------------------------------------------
   Strict mod (container'a data-mahalle-strict):
     Liste doluyken yalnızca listedeki mahalle kabul edilir; eşleşmeyen
     metin blur'da temizlenir. c.reconcile() submit öncesi aynı kontrolü
     yapar. Liste boşsa (ilçe seçilmemiş / servis yanıt vermedi) serbest
     metne izin verilir — aksi halde kullanıcı formu hiç gönderemez.
   ============================================================ */

(function () {
  'use strict';

  function normalize(s) {
    return (s || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function itemName(item) {
    if (typeof item === 'string') return item;
    if (item && typeof item === 'object') {
      return item.name || item.title || item.label || item.mahalle || '';
    }
    return '';
  }

  function attach(container) {
    if (!container || container.dataset.mahalleAttached === '1') return null;
    var input = container.querySelector('[data-mahalle-input]');
    var toggle = container.querySelector('[data-mahalle-toggle]');
    var dropdown = container.querySelector('[data-mahalle-dropdown]');
    if (!input || !dropdown) return null;
    container.dataset.mahalleAttached = '1';

    var strict = container.hasAttribute('data-mahalle-strict');
    var items = [];
    var activeIndex = -1;
    var loadingEl = null;

    function findMatch(value) {
      var n = normalize(value);
      if (!n) return null;
      for (var i = 0; i < items.length; i++) {
        var name = itemName(items[i]);
        if (normalize(name) === n) return name;
      }
      return null;
    }

    /* Strict modda yazılan metni listeye bağlar: birebir (harf/aksan farkı
       gözetmeksizin) eşleşiyorsa listedeki yazıma çeker, eşleşmiyorsa
       temizler. Değer geçerliyse (veya kontrol uygulanmıyorsa) true döner. */
    function reconcile() {
      if (!strict || items.length === 0) return true;
      if (!input.value.trim()) return true;
      var match = findMatch(input.value);
      if (match !== null) {
        input.value = match;
        return true;
      }
      input.value = '';
      return false;
    }

    function setLoading(on) {
      if (on) {
        dropdown.innerHTML = '<div class="mahalle-combobox__loading">Yükleniyor…</div>';
        dropdown.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    }

    function filterItems(q) {
      var n = normalize(q);
      if (!n) return items.slice();
      return items.filter(function (it) {
        return normalize(itemName(it)).indexOf(n) !== -1;
      });
    }

    function render(list) {
      dropdown.innerHTML = '';
      if (!list || list.length === 0) {
        var empty = document.createElement('div');
        empty.className = 'mahalle-combobox__empty';
        if (strict) {
          empty.textContent = items.length === 0
            ? 'İlçe seçince mahalleler listelenir.'
            : 'Eşleşen mahalle yok. Lütfen listeden seçin.';
        } else {
          empty.textContent = items.length === 0
            ? 'İlçe seçince mahalleler önerilir. Adı yazabilirsiniz.'
            : 'Eşleşen mahalle yok. Adı yazabilirsiniz.';
        }
        dropdown.appendChild(empty);
        return;
      }
      list.forEach(function (it, idx) {
        var opt = document.createElement('div');
        opt.className = 'mahalle-combobox__option';
        opt.setAttribute('role', 'option');
        opt.dataset.index = idx;
        opt.textContent = itemName(it);
        opt.addEventListener('mousedown', function (e) {
          e.preventDefault();
          input.value = itemName(it);
          input.removeAttribute('aria-invalid');
          close();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        dropdown.appendChild(opt);
      });
    }

    function open() {
      dropdown.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      render(filterItems(input.value));
    }

    function close() {
      dropdown.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function updateActive() {
      var options = dropdown.querySelectorAll('.mahalle-combobox__option');
      options.forEach(function (opt, idx) {
        if (idx === activeIndex) {
          opt.classList.add('mahalle-combobox__option--active');
          opt.scrollIntoView({ block: 'nearest' });
        } else {
          opt.classList.remove('mahalle-combobox__option--active');
        }
      });
    }

    input.addEventListener('focus', function () { open(); });
    input.addEventListener('input', function () {
      activeIndex = -1;
      open();
    });
    input.addEventListener('blur', function () {
      setTimeout(function () {
        close();
        if (document.activeElement !== input) reconcile();
      }, 150);
    });
    input.addEventListener('keydown', function (e) {
      var options = dropdown.querySelectorAll('.mahalle-combobox__option');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (dropdown.hidden) { open(); return; }
        if (options.length === 0) return;
        activeIndex = Math.min(activeIndex + 1, options.length - 1);
        if (activeIndex < 0) activeIndex = 0;
        updateActive();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (options.length === 0) return;
        activeIndex = Math.max(activeIndex - 1, 0);
        updateActive();
      } else if (e.key === 'Enter') {
        if (!dropdown.hidden && activeIndex >= 0 && options[activeIndex]) {
          e.preventDefault();
          options[activeIndex].dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
        }
      } else if (e.key === 'Escape') {
        close();
      }
    });

    if (toggle) {
      toggle.addEventListener('mousedown', function (e) {
        e.preventDefault();
        if (dropdown.hidden) {
          input.focus();
          open();
        } else {
          close();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) close();
    });

    return {
      setItems: function (newItems) {
        items = Array.isArray(newItems) ? newItems.slice() : [];
        /* Kayıtlı adresten gelen / önceden yazılmış değeri yeni listeye bağla.
           Kullanıcı o an yazıyorsa dokunma; blur'da yapılır. */
        if (document.activeElement !== input) reconcile();
        if (!dropdown.hidden) render(filterItems(input.value));
      },
      reconcile: reconcile,
      setLoading: setLoading,
      clear: function () {
        items = [];
        input.value = '';
        dropdown.innerHTML = '';
      },
      close: close,
      open: open,
      input: input,
      container: container,
    };
  }

  window.MytheMahalle = window.MytheMahalle || {};
  window.MytheMahalle.attach = attach;
  window.MytheMahalle.itemName = itemName;
})();
